import React, { useEffect } from "react";
import { ReactComponent as ProductIcon } from "../../../assets/icons/modal/product.svg";
import { IBrand } from "../../../types/brands.type";
import { ICategory } from "../../../types/category.type";
import { IDiscount } from "../../../types/discount.type";
import { IProductType } from "../../../types/productType.type";
import { ITags } from "../../../types/tags.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddProductForm from "../forms/AddProductForm/AddProductForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  tags: ITags[];
  brands: IBrand[];
  categories: ICategory[];
  types: IProductType[];
  discounts: IDiscount[];
}

const AddProductModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Основна інформація"
          subTitle='Додайте новий продукт до системи. Заповніть основну інформацію про виріб та натисніть "Наступний крок".'
          isLittleMargin={true}
        >
          <ProductIcon />
        </ModalTitle>
        <AddProductForm
          onApply={onApply}
          onClose={props.onClose}
          tags={props.tags}
          brands={props.brands}
          categories={props.categories}
          types={props.types}
          discounts={props.discounts}
        />
      </div>
    </DefaultModal>
  );
};

export default AddProductModal;
